import { useMutation } from "@tanstack/react-query";
import { subscribeForGuide } from "../api/subscribe";
import { track } from "../analytics/track";

/** Подписка на бесплатный гайд. Два call site'а — футер и /subscribe —
 *  шлют одно и то же событие, различаясь только источником. */
export function useSubscribeMutation(source: string) {
  return useMutation({
    mutationFn: subscribeForGuide,
    onSuccess: () => track({ name: "lead", source }),
  });
}
